"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchManaBalance = void 0;
const chain_id_1 = require("@dcl/schemas/dist/dapps/chain-id");
const network_1 = require("@dcl/schemas/dist/dapps/network");
const buildWallet_1 = require("decentraland-dapps/dist/modules/wallet/utils/buildWallet");
const isEthereumAddress_1 = __importDefault(require("validator/lib/isEthereumAddress"));
const rollbar_1 = __importDefault(require("../development/rollbar"));
const segment_1 = __importDefault(require("../development/segment"));
const sentry_1 = __importDefault(require("../development/sentry"));
const Loader_1 = __importDefault(require("./Loader"));
async function fetchManaBalance(address, chainId) {
    if (!(0, isEthereumAddress_1.default)(address)) {
        return {};
    }
    try {
        const { networks } = await (0, buildWallet_1.buildWallet)(chainId);
        const manaBalances = {};
        const networkList = [network_1.Network.ETHEREUM, network_1.Network.MATIC];
        for (const network of networkList) {
            const networkData = networks[network];
            if (networkData) {
                manaBalances[network] = networks[network].mana;
            }
        }
        return manaBalances;
    }
    catch (err) {
        console.error(err);
        (0, rollbar_1.default)((rollbar) => rollbar.error(err));
        (0, sentry_1.default)((sentry) => sentry.captureException(err));
        (0, segment_1.default)((analytics) => analytics.track('error', {
            ...err,
            message: err.message,
            stack: err.stack,
        }));
        return {};
    }
}
exports.fetchManaBalance = fetchManaBalance;
function mapChainIdToNetwork(chainId) {
    switch (chainId) {
        case chain_id_1.ChainId.ETHEREUM_MAINNET:
        case chain_id_1.ChainId.ETHEREUM_SEPOLIA:
            return network_1.Network.ETHEREUM;
        case chain_id_1.ChainId.MATIC_MAINNET:
        case chain_id_1.ChainId.MATIC_AMOY:
            return network_1.Network.MATIC;
        default:
            return network_1.Network.ETHEREUM;
    }
}
function createBalanceLoader(chainId) {
    return new Loader_1.default(async (address) => {
        const manaBalances = await fetchManaBalance(address, chainId);
        return manaBalances[mapChainIdToNetwork(chainId)] || 0;
    });
}
const cache = new Map();
function manaBalance(chainId) {
    if (!cache.has(chainId)) {
        cache.set(chainId, createBalanceLoader(chainId));
    }
    return cache.get(chainId);
}
exports.default = manaBalance;
